import { css } from 'linaria';
import { tagBase } from './tags';
import classNames from 'classnames';
export const suggestedTag = "s9w7e37";
export const SuggestedTag = ({
  children,
  className,
  ...args
}) => <div className={classNames(className, tagBase, suggestedTag)} {...args}>
    {children}
  </div>;

require("./tag-suggested.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./tag-suggested.js");